<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    loadMoreTasks() {
      this.$emit("loadMoreTasks");
    },
  },
};
</script>

<template>
  <div class="btn-more-task" @click="loadMoreTasks">
    <i class="fas fa-spinner fa-spin" v-if="loading"></i>
    <span v-else> Mostrar más tareas... </span>
  </div>
</template>

<style scoped>
.btn-more-task {
  display: inline-block;
  max-height: 50px;
  min-width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  padding: 0.5rem 0;
  &:hover span {
    text-decoration: underline;
  }
}
</style>
